export const VIEW_TYPE = {
  // USER_MANAGEMENT: 'user_management',
  // USER_ASSETS: 'user_asstes',
  ASSET_GROUP_MANAGEMENT:'asset-group_management',

};
